import axios from 'axios';
import config from '../config';
import { rest } from '@ax2/common/index';
import { redirectToAuth } from 'helpers/router';

const restConfig = {
  baseURL: config.baseUrl,
  timeout: 15000,
  withCredentials: true,
};

export const init = () => {
  rest.init(restConfig);
  rest
    .getClient()
    .interceptors.response.use(
      response => response,
      error => authErrorInterceptor(error)
    );
};
interface BaseError {
  response?: { status: number };
}
const authErrorInterceptor = (error: BaseError) => {
  if (error.response && error.response.status === 403) {
    redirectToAuth();
  }
  return Promise.reject({ ...error });
};

export const clientNoInterceptors = axios.create(restConfig);
